// GalleryBanner.js
import React from 'react';
import './GalleryBanner.css'; 
const GalleryBanner = () => {
  return (
     <div className="gallery-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Gallery </h2>
       
      </div>
    </div>
  );
};

export default GalleryBanner;
